import { ComponentPropsWithoutRef } from "react";

import { Theme } from "@radix-ui/themes";

type ThemeProps = ComponentPropsWithoutRef<typeof Theme>;
type RadixColor = ThemeProps["accentColor"];
type RadixGrayColor = ThemeProps["grayColor"];

const accentColor = "green" as RadixColor;
const grayColor = "gray" as RadixGrayColor;

const semanticColor = {
  accent: accentColor,

  danger: "tomato",
  info: "blue",
  success: "grass",
  warning: "amber",
  gray: "gray",
} as const;

const theme = {
  color: semanticColor,
} as const;
type SemanticColor = keyof typeof semanticColor;

/**
 * https://www.radix-ui.com/themes/playground
 */
const radixConfig: ThemeProps = {
  accentColor,
  grayColor,
  panelBackground: "solid",
  radius: "large",
} as const;

export {
  type RadixColor,
  type SemanticColor,
  accentColor,
  grayColor,
  radixConfig,
  semanticColor,
  theme,
};
